import axiosClient from "../lib/api/axiosClient";
const endpoint_two = process.env.REACT_APP_API_ENDPOINT_TWO;
const api_version = process.env.REACT_APP_API_VERSION;

export const AddVehicle = (token, data) =>
  axiosClient
    .post(
      `${endpoint_two}/api/v${api_version}/FleetManagement/AddVehicle`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((res) => res.data)
    .catch((err) => err.response);

export const EditVehicle = (token, data) =>
  axiosClient
    .put(
      `${endpoint_two}/api/v${api_version}/FleetManagement/EditVehicle`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((res) => res.data)
    .catch((err) => err.response);
export const GetAllVehicles = (token) =>
  axiosClient
    .get(`${endpoint_two}/api/v${api_version}/FleetManagement/GetVehicles`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => res.data)
    .catch((err) => err.response);

export const GetSchoolVehicles = (token, id) =>
  axiosClient
    .get(
      `${endpoint_two}/api/v${api_version}/FleetManagement/GetVehicleBySchoolId?schoolId=${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((res) => res.data)
    .catch((err) => err.response);
